import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line import/no-extraneous-dependencies
import { constants } from '@klarna/bubble-ui';
import { Column, Row, gridCalculator } from 'moet-core';

import BodyCell from './BodyCell';
import BodyGutter from './BodyGutter';

const BodyRow = ({ cells, widths = [], gray = false }) => {
  return (
    <Row
      additionalStyles={{
        backgroundColor: gray ? constants.Colors.GRAY : constants.Colors.WHITE,
      }}
    >
      {cells.map((val, index) => {
        const isFirstCell = index === 0;
        const columnWidth =
          widths.length !== 0 ? widths[index] : gridCalculator.MAX_NUMBER_OF_COLUMNS / cells.length;

        return (
          <React.Fragment key={index}>
            {!isFirstCell && <BodyGutter />}
            <Column numberOfColumns={columnWidth}>
              <BodyCell>{val}</BodyCell>
            </Column>
          </React.Fragment>
        );
      })}
    </Row>
  );
};

BodyRow.propTypes = {
  cells: PropTypes.array.isRequired,
  gray: PropTypes.bool,
  widths: PropTypes.array,
};

export default BodyRow;
